const Nav = [
  { title: "Home", url: "/" },
  {
    title: "Dosing",
    url: "/",
    subNav: [
      { title: "Subnav Item 1", url: "/" },
      { title: "Subnav Item 2", url: "/" },
      { title: "Subnav Item 3", url: "/" },
    ],
  },
  {
    title: "Efficacy",
    url: "/",
    subNav: [
      { title: "Subnav Item 1", url: "/" },
      { title: "Subnav Item 2", url: "/" },
      { title: "Subnav Item 3", url: "/" },
    ],
  },
  {
    title: "Safety",
    url: "/",
    subNav: [
      { title: "Subnav Item 1", url: "/" },
      { title: "Subnav Item 2", url: "/" },
      { title: "Subnav Item 3", url: "/" },
    ],
  },
  {
    title: "Contact",
    url: "/",
  },
  {
    title: "Resources",
    url: "/",
  },
];

export default Nav;
